module.exports = __webpack_public_path__ + "img/添加成员.2ce148c6.svg";